import { drama } from '../../../constants/actionTypes';

const initState = [];

export default (state = initState, { type, result }) => {
  switch (type) {
    case drama.FETCH_DRAMA_PINNED_COMMENTS_SUCCESS:
      return [...state, ...result];

    case drama.CLEAN_COMMENTS:
      return initState;

    default:
      return state;
  }
};
